

























































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectMarket} from '@/interfaces/global-data';
import {DownLoadPercent, FilesPageParams, FileType, ServerFile} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeFileStatusMessage, isWritingToDatabase } from '@/utils/backendValueLocalizer';
import LocalData from '@/mixins/local-data';
import {BFormFile} from 'bootstrap-vue';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import Http from '@/mixins/http';
import Toast from '@/mixins/toast';
import Card from '@/components/UI/Card.vue';

interface ITableFilterValues {
    fileNameFilterText: string | null,
    fileUploadDateFilterValue: string | null,
    userNameFilterValue: string | null,
}

@Component({
    components: {
        MarketSelect,
        Card
    },
})
export default class UploadFixedPricesFiles extends Mixins(Http, Toast, LocalData) {
    @Prop() readonly type!: FileType;
    @Prop({required: true}) readonly selectMarket!: SelectMarket;

    table: ServerFile[] = [];
    tableFields: TableHeaders[] = [
        {key: 'id', label: this.$t('shared.labels.numberSign') as string},
        {key: 'tradingNetworks.tradingName', label: this.$t('shared.labels.tradingNetworkShort') as string},
        {key: 'filePath', label: this.$t('shared.table.fileName') as string},
        {key: 'status_warnings', label: this.$t('shared.labels.status') as string},
        {key: 'fileUploadDate', label: this.$t('shared.labels.uploadDateTime') as string},
        {key: 'username', label: this.$t('shared.labels.user') as string},
        {key: 'action', label: ''},
    ];
    newTableFields: any[] = [
        {dataIndex: 'id', title: this.$t('shared.labels.numberSign') as string, width: 100,},
        {dataIndex: 'tradingNetworks.tradingName', title: this.$t('shared.labels.tradingNetworkShort') as string, ellipsis: true, width: 200},
        {
            dataIndex: 'filePath',
            title: this.$t('shared.table.fileName') as string,
            filterModelKey: 'fileNameFilterText',
            scopedSlots: {
                filterDropdown: 'filterTextInput',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
            width: 400,
        },
        {dataIndex: 'status_warnings', title: this.$t('shared.labels.status') as string, ellipsis: true, customRender: (_: undefined, item: ServerFile) => this.showPercentsProgressOrStatus(item)},
        {
            dataIndex: 'fileUploadDate',
            title: this.$t('shared.labels.uploadDateTime') as string,
            filterModelKey: 'fileUploadDateFilterValue',
            scopedSlots: {
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
            width: 200,
        },
        {
            dataIndex: 'username',
            title: this.$t('shared.labels.user') as string,
            filterModelKey: 'userNameFilterValue',
            filterOptionsKey: 'usersFilterOptions',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
            width: 150,
        },
        {dataIndex: 'actions', title: this.$t('shared.labels.actions') as string, scopedSlots: { customRender: 'actions' }, width: 140},
    ];
    pagination: any = {
        current: 1,
        pageSize: 20,
    };
    totalRows: number = 0;
    perPage: number = 20;
    progressCounter: number = 0;
    loadProgress: boolean = false;
    fileIdForDelete: number = -1;
    showDeleteFileModal: boolean = false;
    isTableLoading: boolean = false;
    file: File | null = null;
    tableFilterOptions: any = {};
    tableFilterValues: ITableFilterValues = {
        fileNameFilterText: null,
        fileUploadDateFilterValue: null,
        userNameFilterValue: null,
    };

    disableDeleteButtonConditions(row: ServerFile): boolean {
        return row.status === 'IN_QUEUE_TO_DELETE' || row.status === 'DELETE_FILE' || row.status === 'DELETE_ON_ERROR'
    }

    getFiles(ctx: any, callback: (items: any[]) => void) {
        const pageParams: FilesPageParams = {
            type: this.type,
            size: ctx.perPage,
            page: ctx.currentPage - 1,
        };

        if (this.tableFilterValues.fileNameFilterText) {
            pageParams.fileNameFilterText = this.tableFilterValues.fileNameFilterText;
        }

        if (this.tableFilterValues.fileUploadDateFilterValue) {
            pageParams.fileUploadDateFilterValue = this.tableFilterValues.fileUploadDateFilterValue;
        }

        if (this.tableFilterValues.userNameFilterValue) {
            pageParams.userNameFilterValue = this.tableFilterValues.userNameFilterValue;
        }

        this.isTableLoading = true;

        this.httpGetFileList(pageParams)
            .then((response) => {
                const pagination = { ...this.pagination };
                pagination.total = response.data.totalElements;
                this.pagination = pagination;
                this.table = response.data.content;
                this.totalRows = response.data.totalElements;
                callback(response.data.content);
            })
            .catch((e) => {
                this.showError(this.$t('shared.messages.errorLoadFileList') as string);
                callback([]);
            }).finally(() => {
              this.isTableLoading = false;
        });
    }

    applyFilters() {
        this.getFiles({
            currentPage: 1,
            perPage: this.pagination.pageSize,
        }, () => {});
    }

    uploadFile(event: Event) {
        event.preventDefault();
        if (!this.file) {
            this.showInfo(this.$t('shared.messages.selectFile') as string);
            return;
        }
        if (!this.selectMarket) {
            this.showInfo(this.$t('shared.messages.selectTradingNetwork') as string);
            return;
        }
        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        this.httpUploadFixedPricesFile(this.selectMarket.id, uploadFile)
            .then((r) => {
              this.showInfo(r.data ? r.data : this.$t('fixedPrices.upload.fileIsUploading') as string);
              this.getFiles({
                currentPage: this.pagination.current,
                perPage: this.pagination.pageSize,
              }, () => {});
              this.file = null;
              this.$nextTick(() => {
                this.loadProgress = false;
                this.progressCounter = 0;
              });
            })
            .catch((e) => {
              let message = !!e.response.status && e.response.status != 500
                  ? e.response.data
                  : this.$t('fixedPrices.upload.errorUploadFile') as string
              this.showError(message);
              this.loadProgress = false;
              this.progressCounter = 0;
              this.file = null;
              (this.$refs.fileinput as BFormFile).reset();
            });
    }

    refreshTable() {
        this.getFiles({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {});
    }

    deleteFile(taskId: number) {
        this.httpDeleteFile(taskId)
            .then(() => {
                this.table = this.table.filter((item) => {
                    return item.id !== taskId;
                });
                this.refreshTable();
                this.showInfo(this.$t('shared.messages.fileDeleted') as string);
            })
            .catch((e) => {
                this.showError(this.$t('shared.messages.errorDeleteFile') as string);
            });
    }

    updateTableRowStatus(data: ServerFile) {
        const index = this.table.findIndex((item) => {
            return item.id === data.id;
        });
        if (index === -1) {
            this.table = [data, ...this.table];
            return;
        }
        this.table[index].statusMessage = data.statusMessage;
        if (data.warnings) {
            this.table[index].statusMessage += data.warnings;
        }
        this.refreshTable();
    }

    updateDownloadPercent(percent: DownLoadPercent) {
        const index = this.table.findIndex((item) => {
            return item.id === percent.fileId;
        });
        if (index !== -1) {
            this.table[index].progress = percent.percentDownload;
        }
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;
    }

    showDeleteFileDialog(fileId: number) {
        this.deleteFile(fileId);
    }

    onTableChange(pagination: any) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        this.getFiles({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {});
    }

    downloadTemplate(type: FileType) {
        this.$http.get('/api/file/template', {
            method: 'GET',
            responseType: 'blob',
            params: {
                type,
            },
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const excelFile = this.excelTypeValue(type) + '.xlsx';
            link.setAttribute('download', excelFile)
            document.body.appendChild(link);
            link.click();
        }).catch(() => {
            this.showError(this.$t('shared.messages.errorDownloadFile') as string);
        });
    }

    excelTypeValue(type: FileType) {
        switch (type) {
            case FileType.BASE:
                return 'TemplateSales'
            case FileType.KVICARTS:
                return 'TemplateKviCarts'
            case FileType.COMPETITORS:
                return 'TemplateCompetitors'
            case FileType.PROMO:
                return 'TemplatePromo'
            case FileType.LASTPRICES:
                return 'TemplateLastPrices'
            case FileType.FIXED_PRICE:
                return 'TemplateFixedPrices'
        }
    }

    downloadErrorLog(fileId: number) {
        this.$http.get('/api/error/list', {
            method: 'GET',
            responseType: 'blob',
            params: {
                fileId,
            },
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.$t('fixedPrices.upload.errorsFileName') as string);

            document.body.appendChild(link);
            link.click();
        })
            .catch((e) => {
                this.showError(this.$t('shared.messages.errorDownloadErrorLog') as string);
            });
    }

    showPercentsProgressOrStatus(row: ServerFile): string {
        if (row.progress === '' || !isWritingToDatabase(row.statusMessage)) {
            return localizeFileStatusMessage(row.statusMessage) + '. ' + row.warnings;
        }
        return row.progress;
    }

    mounted() {
        if (this.type === FileType.COMPETITORS) {
            if (this.$disallowedModules.includes('competitors')) {
                this.$router.replace('/calc');
            }
        }
        EventBus.$on('file', this.onFileEventReceived);
        EventBus.$on('downloadProgress', this.onDownloadProgressReceived);

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.getFiles({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})

        if (!this.tableFilterOptions.usersFilterOptions || !this.tableFilterOptions.usersFilterOptions.length) {
            this.httpGetUsersFio()
                .then((response) => {
                    this.tableFilterOptions.usersFilterOptions = response.data.map((i) => {
                        return {value: i, label: i}
                    });
                })
                .catch(() => {
                    this.showError(this.$t('shared.messages.errorLoadUserList') as string);
                });
        }
    }

    created() {
        if (this.type === FileType.PROMO) {
            if (this.$disallowedModules.includes('download-promo')) {
                this.$router.replace('/files');
            }
        }
    }

    beforeDestroy() {
        EventBus.$off('file', this.onFileEventReceived);
        EventBus.$off('downloadProgress', this.onDownloadProgressReceived);
    }

    onFileEventReceived(d: ServerFile) {
        this.updateTableRowStatus(d);
    }

    private onDownloadProgressReceived(p: DownLoadPercent) {
        this.updateDownloadPercent(p);
    }
}
